import TranslationsConfigStore from '../../utils/translations/store/TranslationsConfigStore';
import { FULL_METADATA_MODE_QUERY_PARAM, PARTIAL_METADATA_MODE_QUERY_PARAM } from '../constants';

export type SettingsType = { appName?: string; intervalMillis?: number };

class TranslationsHelper {
  private _store?: TranslationsConfigStore;
  private _appName = 'appName';

  get store(): TranslationsConfigStore {
    return this._store!;
  }

  get appName(): string {
    return this._appName;
  }

  initialize({ intervalMillis, appName }: SettingsType) {
    this._store = new TranslationsConfigStore();
    if (appName) {
      this._appName = appName;
    }
    this._store.initialize({
      fullMode: FULL_METADATA_MODE_QUERY_PARAM,
      partialMode: PARTIAL_METADATA_MODE_QUERY_PARAM
    });
    this.store.utilsInstance.startSearchInterval(intervalMillis || 5000);
  }
}

export default new TranslationsHelper();
